import { useUserSession } from '@/context/user-session-context';

/**
 * @deprecated Use `useUserSession` from `@/context/user-session-context` instead.
 * This alias is kept for backwards compatibility.
 */
export const useSubscription = useUserSession;
